import { ajaxActions } from './AjaxActions';

const BASE_URL = process.env.REACT_APP_DOCUMENT_SERVICE_URL;

export type SequentialNumberType =
  | 'INVOICE_NUMBER'
  | 'OFFER_NUMBER'
  | 'CONFIRMATION_NUMBER'
  | 'PACKING_LIST_NUMBER'
  | 'CANCEL_NUMBER'
  | 'REMINDER_NUMBER'
  | 'DELIVERY_NOTE_NUMBER'
  | 'CONTRACT_NUMBER';

export interface SequentialNumberDto {
  id: number;
  pattern: string;
  sequentialNumber: number;
  minimumLength: number;
  sequentialNumberType: SequentialNumberType;
  profileId: number;
  lastModified: string;
}

const getSequentialNumber = async (sequentialNumberType: SequentialNumberType): Promise<SequentialNumberDto | null> => {
  const res = await ajaxActions.get(`${BASE_URL}/sequentialNumbers/${sequentialNumberType}`);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const setSequentialNumber = async (
  sequentialNumberType: SequentialNumberType,
  sequentialNumber: Partial<SequentialNumberDto>,
): Promise<boolean> => {
  const res = await ajaxActions.post(`${BASE_URL}/sequentialNumbers/${sequentialNumberType}`, sequentialNumber);
  return res.ok;
};

const getNextSequentialNumber = async (
  sequentialNumberType: SequentialNumberType,
  documentId?: number,
): Promise<string | null> => {
  const res = await ajaxActions.put(
    `${BASE_URL}/sequentialNumbers/${sequentialNumberType}${documentId ? `?documentId=${documentId}` : ''}`,
  );
  if (res.ok) {
    const body = (await res.json()) as { nextNumber?: string };
    return body.nextNumber ?? null;
  }
  return null;
};

const patchSequentialNumber = async (
  sequentialNumberType: SequentialNumberType,
  patch: Partial<SequentialNumberDto>,
): Promise<SequentialNumberDto | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/sequentialNumbers/${sequentialNumberType}`, patch);
  if (res.ok) {
    return res.json();
  }
  return null;
};

// eslint-disable-next-line import/prefer-default-export
export const SeqNumberS = {
  getSequentialNumber,
  setSequentialNumber,
  getNextSequentialNumber,
  patchSequentialNumber,
};
